import React, { useState } from "react";
import { Form, Button, Modal, Checkbox, Message, Icon } from "semantic-ui-react";
import { determineAirEmissionsUnits } from "../../../../utils/dataAndFormulas/airemissionsForms";
import { useLanguage } from "../../../../contexts";
import "./UpdateUnitsModal.scss";

export function UpdateUnitsModal(props) {
  const { show, onClose, onApply, currentUnits, registeredFields, isLoading } =
    props;
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const [selectedFields, setSelectedFields] = useState({});
  const [fieldUnits, setFieldUnits] = useState({});

  const allAirEmissionsFields = [
    { key: "carbon_dioxide", label: t("carbon_dioxide") },
    { key: "carbon_monoxide", label: t("carbon_monoxide") },
    { key: "particulate_material", label: t("particulate_material") },
    { key: "volatile_organic_compounds", label: t("volatile_organic_compounds") },
    { key: "sulfur_oxides", label: t("sulfur_oxides") },
    { key: "nitrogen_oxides", label: t("nitrogen_oxides") },
    { key: "chlorofluorocarbons", label: t("chlorofluorocarbons") },
    { key: "hydrochlorofluorocarbons", label: t("hydrochlorofluorocarbons") },
    { key: "hydrofluorocarbons", label: t("hydrofluorocarbons") },
    { key: "hydrofluoroolefins", label: t("hydrofluoroolefins") },
    { key: "perfluorocarbons", label: t("perfluorocarbons") },
    { key: "substances_exhaust_ozone_layer", label: t("substances_exhaust_ozone_layer") },
    { key: "ozone", label: t("ozone") },
    { key: "toxic_or_dangerous_atmospheric_pollutants", label: t("toxic_or_dangerous_atmospheric_pollutants") },
    { key: "ammonia", label: t("ammonia") },
    { key: "propane", label: t("propane") },
    { key: "isobutane", label: t("isobutane") },
    { key: "propylene", label: t("propylene") },
    { key: "ethylene", label: t("ethylene") },
    { key: "hexafluoroethane", label: t("hexafluoroethane") },
    { key: "octafluoropropane", label: t("octafluoropropane") },
    { key: "chlorotrifluoromethane", label: t("chlorotrifluoromethane") },
    { key: "chlorodifluoromethane", label: t("chlorodifluoromethane") },
    { key: "tetrafluoroethane", label: t("tetrafluoroethane") },
    { key: "trifluoromethane", label: t("trifluoromethane") },
    { key: "pentafluoroethane", label: t("pentafluoroethane") },
    { key: "hexafluoropropylene", label: t("hexafluoropropylene") },
    { key: "hydrogen", label: t("hydrogen") },
    { key: "methane", label: t("methane") },
    { key: "oxygen", label: t("oxygen") },
    { key: "nitrogen", label: t("nitrogen") },
    { key: "hydrogen_sulfide", label: t("hydrogen_sulfide") },
    { key: "carbon_disulfide", label: t("carbon_disulfide") },
    { key: "nitrous_oxide", label: t("nitrous_oxide") },
    { key: "hydrochlorofluorocarbons_ref", label: t("hydrochlorofluorocarbons_ref") },
    { key: "hydrofluorocarbons_ref", label: t("hydrofluorocarbons_ref") },
    { key: "hydrofluoroolefins_ref", label: t("hydrofluoroolefins_ref") },
    { key: "perfluorocarbonos_ref", label: t("perfluorocarbonos_ref") },
  ];

  const airEmissionsFields =
    registeredFields && registeredFields.length > 0
      ? registeredFields
          .filter((field) => field.active !== false)
          .map((field) => ({
            key: field.name,
            label: t(field.name),
            code: field.code,
          }))
      : allAirEmissionsFields;

  const handleFieldToggle = (fieldKey, checked) => {
    setSelectedFields((prev) => ({ ...prev, [fieldKey]: checked }));
    if (checked && !fieldUnits[fieldKey]) {
      setFieldUnits((prev) => ({
        ...prev,
        [fieldKey]: currentUnits?.[fieldKey] || "",
      }));
    }
  };

  const handleUnitChange = (fieldKey, unit) => {
    setFieldUnits((prev) => ({ ...prev, [fieldKey]: unit }));
  };

  const handleSelectAll = () => {
    const allSelected = {};
    const allUnits = {};
    airEmissionsFields.forEach((field) => {
      allSelected[field.key] = true;
      allUnits[field.key] = currentUnits?.[field.key] || "";
    });
    setSelectedFields(allSelected);
    setFieldUnits(allUnits);
  };

  const handleDeselectAll = () => {
    setSelectedFields({});
  };

  const handleApply = () => {
    const unitsToApply = {};
    Object.keys(selectedFields).forEach((key) => {
      if (selectedFields[key] && fieldUnits[key]) {
        unitsToApply[key] = fieldUnits[key];
      }
    });
    if (Object.keys(unitsToApply).length === 0) return;
    onApply(unitsToApply);
  };

  const selectedCount = Object.values(selectedFields).filter(Boolean).length;

  return (
    <Modal
      open={show}
      onClose={onClose}
      size="large"
      className="update-units-modal"
    >
      {/* <Modal.Header>
        <Icon name="edit" />
        {t("update_units_in_forms") ||
          "Modificar unidades en formularios existentes"}
      </Modal.Header> */}
      <Modal.Content scrolling>
        {/* <Message info>
          <Message.Header>
            {t("select_fields_to_update") ||
              "Selecciona los campos a modificar"}
          </Message.Header>
          <p>
            {t("update_units_description") ||
              "Selecciona los campos y las unidades que deseas aplicar a todos los formularios existentes del año."}
          </p>
        </Message> */}

        <div style={{ marginBottom: "15px" }}>
          <Button size="small" className="btn-select-all" onClick={handleSelectAll}>
            <Icon name="check square" />{" "}
            {t("select_all") || "Seleccionar todos"}
          </Button>
          <Button size="small" className="btn-deselect-all" onClick={handleDeselectAll}>
            <Icon name="square outline" />{" "}
            {t("deselect_all") || "Deseleccionar todos"}
          </Button>
          <span style={{ marginLeft: "15px", color: "#666" }}>
            {selectedCount} {t("fields_selected") || "campos seleccionados"}
          </span>
        </div>

        <Form>
          <div className="update-units-grid">
            {airEmissionsFields.map((field) => (
              <div key={field.key} className="update-unit-row">
                <Checkbox
                  checked={selectedFields[field.key] || false}
                  onChange={(_, data) =>
                    handleFieldToggle(field.key, data.checked)
                  }
                  label={field.label}
                  className="field-checkbox"
                />
                {selectedFields[field.key] && (
                  <Form.Dropdown
                    placeholder={t("select_unit")}
                    options={determineAirEmissionsUnits(field.key)}
                    selection
                    search
                    compact
                    value={fieldUnits[field.key] || ""}
                    onChange={(_, data) =>
                      handleUnitChange(field.key, data.value)
                    }
                    className="unit-dropdown"
                  />
                )}
              </div>
            ))}
          </div>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button
          primary
          onClick={handleApply}
          disabled={selectedCount === 0 || isLoading}
          loading={isLoading}
        >
          <Icon name="save" />
          {t("apply_to_forms") ||
            `Aplicar a formularios (${selectedCount})`}
        </Button>
        <Button secondary onClick={onClose} disabled={isLoading}>
          {t("cancel")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
